<template>
	<transition name="modal">
		<div ref="mask" class="modal-mask">
			<div ref="wrapper" class="modal-wrapper" @click="clickOnMask">
				<div class="modal-container">
					<div class="close" @click="$emit('close')">
						<slot name="title"></slot>
						<span>&times;</span>
					</div>
					<slot name="content"></slot>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	data: function() {
		return {}
	},
	methods: {
		clickOnMask(event) {
			if (event.target.classList.contains('modal-wrapper')) {
				this.$emit('close')
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.modal-mask {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: center;
	.modal-wrapper {
		border-radius: 2px 2px 0px 0px;
		.modal-container {
			width: 300px;
			margin: 0px;
			padding: 0px; 
			background-color: #fff;
			border-radius: 5px;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
			transition: all 0.3s ease;
			font-family: Helvetica, Arial, sans-serif;

			.close {
				color: #ffffff;
				font-style: normal;
				font-weight: 600;
				font-size: 20px;
				line-height: 30px;
				text-align: center;
				padding: 0.8em 0px;
				background: #fac746;
				border-radius: 2px 2px 0px 0px;
				width: 100%;
				span {
					font-weight: 800;
					padding: 0 9px;
					font-size: 22px;
					float: right;
				}
			}
		}
	}
}

</style>
